import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import {
  HttpErrorResponse,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

export const HttpErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const toastr = inject(ToastrService);
  const routes = inject(Router);
  const spinner = inject(NgxSpinnerService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      error.status == 401 && routes.navigateByUrl('/auth/login');
      if (error.status != 200) {
        toastr.error(error.error.message);
        spinner.hide();
      }
      return throwError(() => error);
    })
  );
};
